import { Middleware } from '@reduxjs/toolkit';

import { api } from '../../services/api';

let previousSalesChannel: string | null = null;

export const salesChannelMiddleware: Middleware = (store) => (next) => (action) => {
  const result = next(action);

  const state = store.getState();
  const currentSalesChannel = state.myVisit.salesChannel;

  if (currentSalesChannel && currentSalesChannel !== previousSalesChannel) {
    previousSalesChannel = currentSalesChannel;
    store.dispatch(api.util.invalidateTags(['Cart', 'Passes', 'Rewards']));
  }

  return result;
};
